import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d6e77ae6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row d-none d-md-flex table__head" }
const _hoisted_2 = { class: "col-3 offset-2 table__header" }
const _hoisted_3 = {
  key: 0,
  class: "col-2 table__header"
}
const _hoisted_4 = {
  key: 1,
  class: "col-2 table__header price"
}
const _hoisted_5 = { class: "col-2 table__header" }
const _hoisted_6 = {
  key: 2,
  class: "col-2 table__header"
}
const _hoisted_7 = {
  key: 3,
  class: "col-2 table__header"
}
const _hoisted_8 = { class: "col-1 table__header" }
const _hoisted_9 = { class: "products-wrapper" }
const _hoisted_10 = { class: "col-2 table__content" }
const _hoisted_11 = ["href"]
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = { class: "col-3 table__content table__text name" }
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 0,
  class: "col-2 table__content table__text table__price"
}
const _hoisted_16 = {
  key: 1,
  class: "col-2 table__content table__text table__price"
}
const _hoisted_17 = { class: "col-2 table__content" }
const _hoisted_18 = {
  key: 2,
  class: "col-2 table__content table__text table__price"
}
const _hoisted_19 = {
  key: 3,
  class: "col-2 table__content table__text table__price"
}
const _hoisted_20 = { class: "col-1 table__content" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 4,
  class: "table__includeditems"
}
const _hoisted_23 = { class: "form-control quantity disabled" }
const _hoisted_24 = {
  key: 5,
  class: "validation-text"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "table__content" }
const _hoisted_27 = { class: "image-container" }
const _hoisted_28 = ["href"]
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "name" }
const _hoisted_31 = ["href"]
const _hoisted_32 = { class: "unit-price" }
const _hoisted_33 = { class: "button-container" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "price-container" }
const _hoisted_36 = {
  key: 0,
  class: "validation-text"
}
const _hoisted_37 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormControlQuantity = _resolveComponent("FormControlQuantity")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("Cart.Product")), 1),
      (_ctx.hidePrices)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t("Cart.Price")), 1)),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("Cart.Quantity")), 1),
      (_ctx.hidePrices)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t("Cart.Total")), 1)),
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("Common.Remove")), 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "row d-none d-md-flex align-items-center justify-content-center table__row",
          key: item.partNo
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("a", {
              href: item.url
            }, [
              _createElementVNode("img", {
                class: "table__image",
                src: item.imageUrl,
                alt: item.name
              }, null, 8, _hoisted_12)
            ], 8, _hoisted_11)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("a", {
              href: item.url
            }, _toDisplayString(item.name), 9, _hoisted_14),
            _createElementVNode("p", null, _toDisplayString(item.productSize), 1)
          ]),
          (_ctx.hidePrices)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15))
            : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.showPricesAsB2b ? (item.priceFormatted) : (item.priceIncVatFormatted)), 1)),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_FormControlQuantity, {
              modelValue: item.unitType == 'kg' ? item.quantityBulkDisplay : item.quantity,
              "onUpdate:modelValue": ($event: any) => (_ctx.onQuantity($event, item.partNo)),
              mode: 2,
              minimumBuyableAmount: item.minimumBuyableAmount,
              maximumBuyableAmount: item.maximumBuyableAmount,
              productType: item.productType,
              unitType: item.unitType
            }, null, 8, ["modelValue", "onUpdate:modelValue", "minimumBuyableAmount", "maximumBuyableAmount", "productType", "unitType"])
          ]),
          (_ctx.hidePrices)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18))
            : (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.showPricesAsB2b ? item.totalFormatted : item.totalIncVatFormatted), 1)),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              class: "table__remove-button",
              onClick: _withModifiers(($event: any) => (_ctx.onRemove(item.partNo)), ["prevent"])
            }, null, 8, _hoisted_21)
          ]),
          (item.includedItems)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.includedItems, (child) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: child.partNo
                  }, [
                    _createTextVNode(_toDisplayString(child.name) + " ", 1),
                    _createElementVNode("span", _hoisted_23, _toDisplayString(child.quantity), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (item && item.maximumBuyableAmount && item.maximumBuyableAmount > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                (item.unitType === 'kg' ? item.quantityBulkDisplay >= item.maximumBuyableAmount : item.quantity >= item.maximumBuyableAmount)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(item.maximumBuyableAmount) + " " + _toDisplayString(_ctx.$t("Cart.ReachedMaxQuantity")), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "row table__row mobile",
        key: item.partNo
      }, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("a", {
              href: item.url
            }, [
              _createElementVNode("img", {
                class: "table__image",
                src: item.imageUrl
              }, null, 8, _hoisted_29)
            ], 8, _hoisted_28),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("a", {
                href: item.url
              }, _toDisplayString(item.name), 9, _hoisted_31),
              _createElementVNode("p", null, _toDisplayString(item.productSize), 1)
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("p", null, _toDisplayString(_ctx.showPricesAsB2b ? (item.priceFormatted) : (item.priceIncVatFormatted)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("button", {
              class: "table__remove-button",
              onClick: _withModifiers(($event: any) => (_ctx.onRemove(item.partNo)), ["prevent"])
            }, null, 8, _hoisted_34),
            _createVNode(_component_FormControlQuantity, {
              modelValue: item.unitType == 'kg' ? item.quantityBulkDisplay : item.quantity,
              "onUpdate:modelValue": ($event: any) => (_ctx.onQuantity($event, item.partNo)),
              mode: 1,
              minimumBuyableAmount: item.minimumBuyableAmount,
              maximumBuyableAmount: item.maximumBuyableAmount,
              productType: item.productType,
              unitType: item.unitType
            }, null, 8, ["modelValue", "onUpdate:modelValue", "minimumBuyableAmount", "maximumBuyableAmount", "productType", "unitType"])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_35, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("Checkout.Total")), 1),
            _withDirectives(_createElementVNode("p", { class: "price" }, _toDisplayString(_ctx.showPricesAsB2b ? item.totalFormatted : item.totalIncVatFormatted), 513), [
              [_vShow, !_ctx.hidePrices]
            ])
          ], 512), [
            [_vShow, !_ctx.hidePrices]
          ]),
          (item && item.maximumBuyableAmount && item.maximumBuyableAmount > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                (item.unitType === 'kg' ? item.quantityBulkDisplay >= item.maximumBuyableAmount : item.quantity >= item.maximumBuyableAmount)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(_ctx.$t("Cart.ReachedMaxQuantity")), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128))
  ], 64))
}